module.exports = __webpack_public_path__ + "static/img/his-Asset-84.b246a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-Asset-84.png
// module id = AG+4
// module chunks = 2